import React from 'react'
// libs
// containers
import PublicRiskEditContainer from 'containers/Risks/Risk/Edit/public'

const PublicRiskPage: React.FC = () => <PublicRiskEditContainer />

export default PublicRiskPage
